window.Vue = require('vue/dist/vue.js')
import jQuery from 'jquery'
import axios from 'axios'
import lodash from 'lodash-es'
import moment from 'moment'
import 'moment/locale/fr'
import EventBus from './event-bus'
import VueRouter from 'vue-router'
import store from './stores/store'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { setInteractionMode } from 'vee-validate'
import i18n from './i18n.js'
import Profile from './components/Profile/index.vue'
import { mapFields } from 'vuex-map-fields'
import Cookies from 'js-cookie';
import { mapGetters } from 'vuex'

import {
  required,
  email,
  numeric,
  digits,
  min,
  confirmed,
  is,
  required_if,
  oneOf,
  regex
} from 'vee-validate/dist/rules'
import './common'

/*
 *
 */
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import '../scss/profile.scss'
import '../scss/_vue2-datepicker.scss'
import 'vue2-datepicker/locale/fr'
import 'vue2-datepicker/locale/en'
import '../scss/_vue-treeselect.scss'
/*
 *
 */
let locale = document.head.querySelector('meta[name="app-locale"]').content
moment.locale(locale)

extend('oneOf', {
  ...oneOf,
  // message: 'Le champ est invalide'
})
extend('is', {
  ...is,
  message: i18n.t('errors.invalidField')
})
extend('confirmed', {
  ...confirmed,
  message: i18n.t('errors.passwordMatch'),
})
extend('required', {
  ...required,
  message: i18n.t('errors.requiredFields'),
})
extend('required_if', {
  ...required_if,
  message: i18n.t('errors.requiredFields'),
})
extend('email', {
  ...email,
  message: i18n.t('errors.invalidEmail'),
})
extend('numeric', {
  ...numeric,
  message: i18n.t('errors.mustBeNumber'),
})
extend('min', {
  ...min,
  message: i18n.t('errors.threeDigits'),
})
extend('mimes', {
  ...min,
  message: i18n.t('errors.fileType'),
})
extend('passwordRegex', {
  ...regex,
  message: i18n.t('errors.passwordRegex'),
})
extend('passwordMin', {
  ...min,
  message: i18n.t('errors.passwordLength'),
})
/*
 *
 */
import '../scss/profile.scss'
window.$ = window.jQuery = jQuery

const token = Cookies.get('clientToken');

if (token) {
  axios.defaults.headers.common['Authorization'] = token
} else console.error(' Token not found')

/*
 *
 */
Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus
    },
  },
})

/*
 *
 */
import MyAccount from './components/Profile/my-account/index.vue'
import MyTeam from './components/Profile/my-team/index.vue'
import MyTrainingPlan from './components/Profile/my-training-plan/index.vue'
import MyInvoices from './components/Profile/my-invoices/index.vue'
import MySessions from './components/Profile/my-sessions/index.vue'
import MyCompanies from './components/Profile/my-companies/index.vue'
import TraineeInfo from './components/Profile/my-team/TraineeInfo.vue'
import Registrations from './components/Profile/registrations/index.vue'
import TraineeRegistrations from './components/Profile/trainee-registrations/index.vue'
import Results from './components/Profile/results/index.vue'
import TraineeResults from './components/Profile/trainee-results/index.vue'
import Habilitations from './components/Profile/habilitations/index.vue'
import TraineeHabilitations from './components/Profile/trainee-habilitations/index.vue'
import MyMonitoring from './components/Profile/monitoring/index.vue'
import Vue2Debounce from 'vue2-debounce';

/*
 *
 */
Vue.use(VueRouter)
Vue.use(Vue2Debounce);
/*
 * Global Components registration
 */
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('profile', Profile)
Vue.component(
  'forgot-password-modal',
  require('./components/modals/ForgotPasswordModal.vue').default
)
Vue.component(
  'cart-modal',
  require('./components/modals/CartModal.vue').default
)
Vue.component(
  'phone-modal',
  require('./components/modals/PhoneModal.vue').default
)
Vue.component(
  'search-modal',
  require('./components/modals/SearchModal.vue').default
)
Vue.component(
  'contact-modal',
  require('./components/modals/ContactModal.vue').default
)
Vue.component(
  'login-modal',
  require('./components/modals/LoginModal.vue').default
)
Vue.component(
  'signup-modal',
  require('./components/modals/SignupModal.vue').default
)

Vue.component('profile', require('./components/Profile/index.vue').default)

const router = new VueRouter({
  routes: [
    {
      name: 'index',
      path: '/',
      redirect:
        store?.state?.user?.clientType === 'trainee' ||
        store?.state?.user?.clientType === 1 ||
        store?.state?.user?.clientType === 5
          ? '/my-account'
          : '/my-companies',
    },
    {
      name: 'MyCompanies',
      path: '/my-companies',
      component: MyCompanies,
    },
    {
      name: 'MyAccount',
      path: '/my-account',
      component: MyAccount,
    },
    {
      name: 'MyTeam',
      path: '/my-team',
      component: MyTeam,
    },
    {
      name: 'MyTrainingPlan',
      path: '/my-training-plan',
      component: MyTrainingPlan,
    },
    {
      name: 'Registrations',
      path: '/registrations',
      component: Registrations,
    },
    {
      name: 'TraineeRegistrations',
      path: '/trainee-registrations',
      component: TraineeRegistrations,
    },
    {
      name: 'Results',
      path: '/results',
      component: Results,
    },
    {
      name: 'TraineeResults',
      path: '/trainee-results',
      component: TraineeResults,
    },
    {
      name: 'MySessions',
      path: '/my-sessions',
      component: MySessions,
    },
    {
      name: 'MyInvoices',
      path: '/my-invoices',
      component: MyInvoices,
    },
    {
      name: 'TraineeInfo',
      path: '/trainee/:id',
      component: TraineeInfo,
    },
    {
      name: 'Habilitations',
      path: '/habilitations',
      component: Habilitations,
    },
    {
      name: 'TraineeHabilitations',
      path: '/trainee-habilitations',
      component: TraineeHabilitations,
    },
    {
      name: 'MyMonitoring',
      path: '/my-monitoring',
      component: MyMonitoring,
    },
  ],
  scrollBehavior() {
    window.scrollTo(0, 0)
  },
})

var app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  data: {},
  computed: {
    ...mapFields(['cart', 'user']),
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    let apiBaseURL = document.head.querySelector('meta[name="api-baseurl"]')
    this.$store.commit('SET_API_BASEURL', apiBaseURL.content)

    /*let params = {
      includes: ['trainees', 'newsletters', 'sessions', 'toClients.clients'],
    }
    this.$store.dispatch('getAccountInformations', params).then(() => {
      this.$store.dispatch('getNewsletters')
    })*/
    if (!this.isLoggedIn) {
      window.location = '/'
    }
  },
  mounted() {},
})
